import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Loader from '~components/Loader'
import { loadPage } from '~redux/content'
import Heading from '~components/Heading'
import { pageView } from '~helpers/ga'

class Page extends React.Component {
  componentDidMount () {
    pageView()

    const url = window.location.href
    const page = url.split('/').pop()

    this.props.loadPage(page)
  }

  render () {
    if (!this.props.content) {
      return <Loader />
    }

    return (
      <>
        <Heading
          title={this.props.content.title}
          className="mt-10"
        />

        <div className="xxl:container mx-auto px-4 md:px-8 xxl:px-0 my-10 xl:my-20">
          <div className="w-full flex flex-wrap -my-1 -mx-1 md:-mx-2 md:-my-3 xxl:-mx-5 xl:-my-10 generic">
            <div dangerouslySetInnerHTML={{ __html: this.props.content.fields.content }} />
          </div>
        </div>
      </>
    )
  }
}

Page.propTypes = {
  content: PropTypes.object,
  loadPage: PropTypes.func
}

const mapStateToProps = (state) => {
  const url = window.location.href
  const page = url.split('/').pop()

  return {
    content: state.content[page] || null
  }
}

const mapDispatchToProps = dispatch => ({
  loadPage: page => { dispatch(loadPage(page)) }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Page)
